import React from "react";
import TextToSpeech from "./TextToSpeech";

const TextToSpeechTranslation = () => {
  return <TextToSpeech />;
};

export default TextToSpeechTranslation;
